// extracted by mini-css-extract-plugin
module.exports = {"root":"LoadMoreObserver_root__3IXV7","rootCenter":"LoadMoreObserver_rootCenter__1xKHc","noPaddingBottom":"LoadMoreObserver_noPaddingBottom__3wfka"};